import React from 'react';
import { Form } from 'react-bootstrap';
import { DateTime } from 'luxon';

const Sidebar = ({ filters, onFilterChange }) => {
  const handleSearchChange = e => {
    onFilterChange({ search: e.target.value });
  };

  const handleStartDateChange = e => {
    onFilterChange({ startDate: e.target.value });
  };

  const handleProfileTypeChange = e => {
    const value = e.target.value;
    const updatedTypes = filters.profileTypes.includes(value)
      ? filters.profileTypes.filter(type => type !== value)
      : [...filters.profileTypes, value];
    onFilterChange({ profileTypes: updatedTypes });
  };

  const handleStatusChange = e => {
    const value = e.target.value;
    const updatedStatus = filters.status.includes(value)
      ? filters.status.filter(status => status !== value)
      : [...filters.status, value];
    onFilterChange({ status: updatedStatus });
  };

  // Get today's date in YYYY-MM-DD format for max date
  const today = DateTime.now().toFormat('yyyy-MM-dd');

  return (
    <div className="p-4">
      <h5 className="mb-4">Filters</h5>
      <Form>
        <Form.Group className="mb-4">
          <Form.Label>Search</Form.Label>
          <Form.Control
            type="text"
            placeholder="Search by wallet"
            value={filters.search}
            onChange={handleSearchChange}
          />
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>Start Date</Form.Label>
          <Form.Control
            type="date"
            value={filters.startDate || ''}
            onChange={handleStartDateChange}
            max={today}
          />
          <Form.Text className="text-muted">Show profiles from this date onwards</Form.Text>
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>Profile Type</Form.Label>
          <div>
            <Form.Check
              type="checkbox"
              label="Primary"
              value="primary"
              checked={filters.profileTypes.includes('primary')}
              onChange={handleProfileTypeChange}
            />
            <Form.Check
              type="checkbox"
              label="Sub"
              value="secondary"
              checked={filters.profileTypes.includes('secondary')}
              onChange={handleProfileTypeChange}
            />
          </div>
        </Form.Group>

        <Form.Group className="mb-4">
          <Form.Label>Status</Form.Label>
          <div>
            <Form.Check
              type="checkbox"
              label="Completed"
              value="COMPLETED"
              checked={filters.status.includes('COMPLETED')}
              onChange={handleStatusChange}
            />
            <Form.Check
              type="checkbox"
              label="Needs Review"
              value="NEEDS_REVIEW"
              checked={filters.status.includes('NEEDS_REVIEW')}
              onChange={handleStatusChange}
            />
            <Form.Check
              type="checkbox"
              label="Declined"
              value="DECLINED"
              checked={filters.status.includes('DECLINED')}
              onChange={handleStatusChange}
            />
          </div>
        </Form.Group>
      </Form>
    </div>
  );
};

export default Sidebar;
